export enum CawTier {
  SEED = 'seed',
  GROW = 'grow',
  BLOOM = 'bloom',
}
